const singleFillTranslation = (translation: string, value: string | number) => {
    return translation?.replace(
        /\::(.*?)\::/,
        typeof value === 'number' ? value.toString() : (value as string)
    );
};

const multiFillTranslation = (
    translation: string,
    value: {
        [key: string]: string;
    }
) => translation.replace(/::(.*?)::/g, (keyFound, valueKey) => value[valueKey] || keyFound);

export const fillTranslation = (
    translation: string,
    value:
        | string
        | number
        | {
              [key: string]: string;
          }
) => {
    if (typeof value !== 'object') {
        return singleFillTranslation(translation, value);
    }

    return multiFillTranslation(translation, value);
};
